<template>
  <div class="order-summary">
    <div v-if="basket">
        <span v-if="basket.original_total">Order Subtotal: <strong>£{{ basket.original_total|money }}</strong></span>
        <span v-else>Order Subtotal: <strong>£{{ basket.total|money }}</strong></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
    };
  },

  props: {
    basket: {
      type: Object,
    },
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },
};
</script>
